<template>
  <div class="select-if-claim-program" data-test-id="select-if-claim-program">
    <div class="select-if-claim-program__copy">
      <Typography variant="h-2" as="h1">
        First things first — is this a claims program?
      </Typography>
      <Typography variant="body-1">We'll set up the right steps to get you started.</Typography>
    </div>
    <div class="select-if-claim-program__choices">
      <v-card
        v-for="choice in choices"
        :key="choice.label"
        outlined
        class="select-if-claim-program__choice"
        role="button"
        tabindex="0"
        :data-test-id="choice.testId"
        @click="$emit('select', choice.isClaim)"
        @keydown.enter="$emit('select', choice.isClaim)"
        @keydown.space.prevent="$emit('select', choice.isClaim)"
      >
        <Typography variant="h-5" class="select-if-claim-program__choice-label">
          {{ choice.label }}
        </Typography>
        <Icon icon="mdi-chevron-right" :medium="false" />
      </v-card>
    </div>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Icon from "@/components/generic/Icon.vue";

export default {
  name: "SelectIfClaimProgram",
  components: {
    Typography,
    Icon,
  },
  emits: ["select"],
  data() {
    return {
      choices: [
        { label: "Yes", isClaim: true, testId: "claim-program-yes" },
        { label: "No", isClaim: false, testId: "claim-program-no" },
      ],
    };
  },
};
</script>

<style scoped>
.select-if-claim-program {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 115px 24px 24px;
}

.select-if-claim-program__copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: 540px;
  text-align: center;
}

.select-if-claim-program__choices {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 444px;
}

.select-if-claim-program__choice {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  cursor: pointer;
}

.select-if-claim-program__choice-label {
  flex: 1 1 0;
  min-width: 0;
  text-align: left;
}
</style>
